exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".allcontacts-1{fill:none}.allcontacts-2{fill:#ee7470;opacity:.331}.allcontacts-3{fill:#1e4e69}.allcontacts-4{fill:#72cac2;opacity:.375}.allcontacts-5{fill:#faedb1}\n", ""]);
